/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  PayableOverrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MockPiggyBankBomb,
  MockPiggyBankBombInterface,
} from "../MockPiggyBankBomb";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint16",
        name: "_bombTimerMaxSeconds",
        type: "uint16",
      },
    ],
    stateMutability: "payable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_balance",
        type: "uint256",
      },
    ],
    name: "GameStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_winner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "WinningsStored",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_winner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "WinningsWithdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "_mock_setBlockTimeStamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bombTimerMaxSeconds",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "calculateMinDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "fakeBlockTimeStamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastDepositAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastDepositTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "piggyBankBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "startNewGame",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "winnerBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawWinnings",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MockPiggyBankBomb__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _bombTimerMaxSeconds: BigNumberish,
    overrides?: PayableOverrides & { from?: string | Promise<string> }
  ): Promise<MockPiggyBankBomb> {
    return super.deploy(
      _bombTimerMaxSeconds,
      overrides || {}
    ) as Promise<MockPiggyBankBomb>;
  }
  getDeployTransaction(
    _bombTimerMaxSeconds: BigNumberish,
    overrides?: PayableOverrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_bombTimerMaxSeconds, overrides || {});
  }
  attach(address: string): MockPiggyBankBomb {
    return super.attach(address) as MockPiggyBankBomb;
  }
  connect(signer: Signer): MockPiggyBankBomb__factory {
    return super.connect(signer) as MockPiggyBankBomb__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockPiggyBankBombInterface {
    return new utils.Interface(_abi) as MockPiggyBankBombInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockPiggyBankBomb {
    return new Contract(address, _abi, signerOrProvider) as MockPiggyBankBomb;
  }
}
